import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoahmednagarcab() {



  const cardData =
  {
    keyword: 'Mumbai to Ahmednagar Cab',
    heading: 'Shambhu Cabs: Mumbai to Ahmednagar Cab  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Ahmednagar Cab services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and weekend visitors. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient journey from Mumbai to Ahmednagar with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free and enjoyable. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Ahmednagar cab services for travelers seeking comfort, safety, and reliability throughout the journey.',

    top: 'Top Places to Visit in Ahmednagar with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Ahmednagar Fort",
    "description": "Ahmednagar Fort, built in the 15th century, is a historic fort known for its massive walls, gateways, and deep moat. The fort has witnessed many battles and houses tombs of notable rulers, making it a significant landmark for history enthusiasts."
  },
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Located near Ahmednagar, the Shirdi Sai Baba Temple is one of India’s most revered pilgrimage sites. Devotees visit to seek blessings, participate in spiritual ceremonies, and explore the surrounding sacred complexes and Samadhi Mandir of Sai Baba."
  },
  {
    "title": "Meherabad",
    "description": "Meherabad is the resting place of the spiritual saint Meher Baba. It includes his samadhi, ashrams, and pilgrimage facilities. Visitors come here for meditation, spiritual retreats, and to experience the tranquil environment created by the saint’s teachings."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Shani Shingnapur is famous for its unique shrine dedicated to Lord Shani, where houses in the village traditionally have no doors. Devotees visit to pray for protection and prosperity, and the temple is known for its fascinating cultural practices."
  },
  {
    "title": "Bhandardara Dam & Arthur Lake",
    "description": "Bhandardara Dam, creating Arthur Lake, is a scenic spot in the Ahmednagar district surrounded by hills and waterfalls. It is popular for boating, picnics, and nature photography, especially during the monsoon when the surroundings are lush and green."
  },
  {
    "title": "Randha Falls",
    "description": "Randha Falls, near Bhandardara, is a stunning waterfall formed by the Pravara River. Visitors enjoy trekking, photography, and the breathtaking natural beauty of this cascade, particularly during the rainy season."
  },
  {
    "title": "Harishchandragad Fort",
    "description": "Harishchandragad Fort is a historic hill fort famous for its challenging treks, ancient temples, and stone structures. The fort offers panoramic views of the Sahyadri ranges and attracts adventure enthusiasts and history buffs alike."
  },
  {
    "title": "Kalsubai Peak",
    "description": "Kalsubai Peak, the highest point in Maharashtra, is a popular trekking destination. Adventurers climb the peak to witness sunrise, panoramic views of the Western Ghats, and diverse flora and fauna along the trail."
  },
  {
    "title": "Shirdi Wetlands & Rural Trails",
    "description": "The surrounding rural areas and wetlands near Ahmednagar offer serene landscapes, birdwatching opportunities, and traditional village experiences. These trails are ideal for nature lovers and photographers seeking offbeat destinations."
  },
  {
    "title": "Ralegan Siddhi",
    "description": "Ralegan Siddhi is a model village developed by social reformer Anna Hazare. Known for its sustainable practices, clean environment, and community development, the village attracts visitors interested in rural development and eco-tourism."
  }
],


"services": [
  {
    "name": "Mumbai Ahmednagar Taxi",
    "description": "Mumbai Ahmednagar Taxi provides reliable and comfortable travel between Mumbai and Ahmednagar. With professional drivers, well-maintained vehicles, and flexible scheduling options, this service ensures a smooth and safe journey. Ideal for business travelers, families, and solo passengers, it offers a hassle-free intercity travel experience with timely pickups and drop-offs."
  },
  {
    "name": "Ahmednagar Car Hire Mumbai",
    "description": "Ahmednagar Car Hire Mumbai offers convenient and flexible vehicle rental options for trips from Mumbai to Ahmednagar. Customers can choose from sedans, SUVs, or premium cars with professional chauffeurs. The service is designed for comfort, safety, and efficiency, making it perfect for corporate travel, leisure trips, and family outings."
  },
  {
    "name": "One-Way Cab Mumbai Ahmednagar",
    "description": "One-Way Cab Mumbai Ahmednagar is ideal for travelers requiring single-direction travel without a return journey. Perfect for airport transfers, business trips, or personal travel, this service provides affordable pricing, professional drivers, and comfortable vehicles to ensure a stress-free journey."
  },
  {
    "name": "Affordable Mumbai Ahmednagar Cab",
    "description": "Affordable Mumbai Ahmednagar Cab offers budget-friendly intercity travel options without compromising on comfort or safety. Ideal for students, small families, and frequent travelers, the service provides well-maintained vehicles, professional drivers, and transparent pricing for a reliable and economical journey."
  },
  {
    "name": "Mumbai Ahmednagar Outstation Taxi",
    "description": "Mumbai Ahmednagar Outstation Taxi specializes in long-distance travel from Mumbai to Ahmednagar with a focus on passenger safety and comfort. Vehicles are equipped with modern amenities, and drivers are experienced in managing highway routes, ensuring a smooth and enjoyable ride for both leisure and business travelers."
  },
  {
    "name": "SUV Cab Ahmednagar Trip",
    "description": "SUV Cab Ahmednagar Trip caters to families or groups needing spacious and comfortable vehicles for intercity travel. Equipped with air-conditioning and safety features, these SUVs provide a relaxed journey from Mumbai to Ahmednagar, making it ideal for long drives, sightseeing, or weekend getaways."
  },
  {
    "name": "Sedan Cab Mumbai Ahmednagar",
    "description": "Sedan Cab Mumbai Ahmednagar offers efficient and comfortable sedans for solo travelers, couples, or small families. With professional drivers, clean vehicles, and timely service, this option ensures a convenient and smooth journey between Mumbai and Ahmednagar for business or leisure purposes."
  },
  {
    "name": "Best Cab Mumbai Ahmednagar",
    "description": "Best Cab Mumbai Ahmednagar is known for its superior service, well-maintained vehicles, and punctual drivers. Passengers enjoy a hassle-free journey with professional support, flexible booking options, and a focus on safety and comfort, making it a preferred choice for intercity travel."
  },
  {
    "name": "24×7 Mumbai Ahmednagar Taxi",
    "description": "24×7 Mumbai Ahmednagar Taxi provides round-the-clock availability for travelers needing flexible timing. With professional drivers, well-kept vehicles, and on-demand booking, this service ensures a safe, comfortable, and reliable journey any time of the day or night."
  },
  {
    "name": "Fast Cab Mumbai Ahmednagar",
    "description": "Fast Cab Mumbai Ahmednagar focuses on punctual and time-efficient travel. Ideal for business travelers and urgent trips, this service provides direct routes, professional drivers, and well-maintained vehicles to ensure a quick and smooth journey between Mumbai and Ahmednagar."
  },
  {
    "name": "Corporate Cab Mumbai Ahmednagar",
    "description": "Corporate Cab Mumbai Ahmednagar is designed for business travelers and corporate groups. Premium vehicles, experienced chauffeurs, and flexible schedules ensure timely arrivals, professional service, and a comfortable journey for meetings, office transfers, and corporate events."
  },
  {
    "name": "Mumbai Ahmednagar Travel Cab",
    "description": "Mumbai Ahmednagar Travel Cab provides reliable intercity travel with a focus on passenger convenience and comfort. The service offers a variety of vehicle options, professional drivers, and timely pickups, making it suitable for leisure trips, family outings, and business travel."
  },
  {
    "name": "Premium Ahmednagar Cab",
    "description": "Premium Ahmednagar Cab offers luxury vehicles and professional chauffeur-driven services for a high-end travel experience from Mumbai to Ahmednagar. Ideal for executives, families, and VIP travelers, this service ensures comfort, safety, and style on long-distance journeys."
  },
  {
    "name": "Safe Taxi Mumbai Ahmednagar",
    "description": "Safe Taxi Mumbai Ahmednagar emphasizes passenger safety with well-maintained vehicles, experienced drivers, and adherence to all travel safety protocols. Perfect for families, solo travelers, and corporate clients, this service ensures a secure and reliable journey from Mumbai to Ahmednagar."
  },
  {
    "name": "Family Cab Mumbai Ahmednagar",
    "description": "Family Cab Mumbai Ahmednagar caters specifically to family trips with spacious vehicles, professional drivers, and flexible itineraries. Passengers can enjoy sightseeing, comfort, and a smooth ride for weekend getaways, vacations, and leisure travel from Mumbai to Ahmednagar."
  },
  {
    "name": "Express Highway Cab Ahmednagar",
    "description": "Express Highway Cab Ahmednagar provides fast and efficient travel along highways connecting Mumbai and Ahmednagar. With professional drivers, direct routes, and well-maintained vehicles, passengers can reach their destination quickly while enjoying a safe and comfortable journey."
  },
  {
    "name": "Mumbai Ahmednagar Pickup Drop",
    "description": "Mumbai Ahmednagar Pickup Drop ensures door-to-door service for passengers traveling between Mumbai and Ahmednagar. The service offers professional drivers, well-maintained vehicles, and flexible timing, providing maximum convenience and a hassle-free travel experience for all passengers."
  }
],

"tableData": [
  ["Mumbai Ahmednagar Taxi", "Ahmednagar Car Hire Mumbai"],
  ["One-Way Cab Mumbai Ahmednagar", "Affordable Mumbai Ahmednagar Cab"],
  ["Mumbai Ahmednagar Outstation Taxi", "SUV Cab Ahmednagar Trip"],
  ["Sedan Cab Mumbai Ahmednagar", "Best Cab Mumbai Ahmednagar"],
  ["24×7 Mumbai Ahmednagar Taxi", "Fast Cab Mumbai Ahmednagar"],
  ["Corporate Cab Mumbai Ahmednagar", "Mumbai Ahmednagar Travel Cab"],
  ["Premium Ahmednagar Cab", "Safe Taxi Mumbai Ahmednagar"],
  ["Family Cab Mumbai Ahmednagar", "Express Highway Cab Ahmednagar"],
  ["Mumbai Ahmednagar Pickup Drop", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Ahmednagar Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Ahmednagar cab services, ideal for business trips, family travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and well-maintained cabs for a smooth and comfortable journey to Ahmednagar."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Outstation Routes",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Ahmednagar route, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Ahmednagar cab trip stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Ahmednagar travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai to Ahmednagar journey smooth and comfortable."
  }
]





















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Ahmednagar cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Ahmednagar cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Ahmednagar cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Ahmednagar cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for safe and comfortable long-distance travel.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Ahmednagar route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai to Ahmednagar route to ensure a smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Ahmednagar cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere in Ahmednagar.',
  },
  {
    question: 'Is the Mumbai to Ahmednagar cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Ahmednagar cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Ahmednagar cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Ahmednagar cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Ahmednagar journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Ahmednagar travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh Patil',
    feedback: 'Our Mumbai to Ahmednagar trip with Shambhu Cabs was comfortable and hassle-free. The driver was courteous and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rekha Deshmukh',
    feedback: 'Highly reliable Mumbai to Ahmednagar cab service. Smooth journey and excellent support from Shambhu Cabs.',
    rating: 5,
  },
];














































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ahmednagar Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-ahmednagar-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Ahmednagar cab services for comfortable and safe travel. Book one-way or round-trip taxis with sedans, SUVs, or premium cars. Ideal for family trips, corporate travel, highway travel, and express journeys with professional drivers and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-ahmednagar-cab"
  }
};






  return (
    <div>
      <Helmet>
  <title>Mumbai to Ahmednagar Cab | Outstation & Highway Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Ahmednagar cab with Shambhu Cabs. Safe, fast, and affordable taxi service for one-way and round trips, family travel, corporate travel, and highway trips. Available 24×7 with sedans, SUVs, and premium cars."
  />

  <meta
    name="keywords"
    content="Mumbai Ahmednagar Taxi, Ahmednagar Car Hire Mumbai, One-Way Cab Mumbai Ahmednagar, Affordable Mumbai Ahmednagar Cab, Mumbai Ahmednagar Outstation Taxi, SUV Cab Ahmednagar Trip, Sedan Cab Mumbai Ahmednagar, Best Cab Mumbai Ahmednagar, 24×7 Mumbai Ahmednagar Taxi, Fast Cab Mumbai Ahmednagar, Corporate Cab Mumbai Ahmednagar, Mumbai Ahmednagar Travel Cab, Premium Ahmednagar Cab, Safe Taxi Mumbai Ahmednagar, Family Cab Mumbai Ahmednagar, Express Highway Cab Ahmednagar, Mumbai Ahmednagar Pickup Drop"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoahmednagarcab;